class UGLink extends HTMLElement {
  constructor() {
    super();
    // Shadow DOM encapsulation
    // this.attachShadow({ mode: 'open' });
    // 创建一个a标签
    this.linkElement = document.createElement('a');
    this.linkElement.target = "_blank";
    // 将a标签添加到shadow DOM中
    // this.appendChild(this.linkElement);
  }

  connectedCallback() {
    this.updateLink();
    // 将传递给自定义元素的 class 属性应用到 a 标签上
    this.linkElement.className = this.getAttribute('class') || '';
    this.linkElement.style.textDecoration = 'none';
    // 将所有的子元素移动到 a 标签内部
    while (this.firstChild) {
      this.linkElement.appendChild(this.firstChild);
    }
    // 将a标签  插入到自定义元素中
    this.appendChild(this.linkElement);
  }

  // 根据 locale 更新链接
  updateLink() {
    
    const locale = navigator.language || navigator.userLanguage; // 获取用户的语言设置
    const productLink = this.getAttribute('product-link'); // 获取nas 自身的产品链接
    const usLink = this.getAttribute('us-link'); // 获取us链接
    const deLink = this.getAttribute('de-link'); // 获取de链接
    if(productLink){
      this.linkElement.href = productLink;
    }else{
      this.linkElement.href = window.UgreenInfo.ugmarketHandle.toLocaleLowerCase() == 'de' ? deLink : usLink; 
    }
  }
}

// 注册自定义元素
customElements.define('ug-link', UGLink);